import {ChangeDetectorRef, Component, OnDestroy, OnInit} from '@angular/core';
import {MatDialog, MatDialogRef} from '@angular/material/dialog';
import {EventDismissComponent} from '../../../modules/events/components/event-dismiss/event-dismiss.component';
import {takeUntil} from 'rxjs/operators';
import {Subject} from 'rxjs';
import {EventsService} from '../../../core/services/events.service';

@Component({
  selector: 'app-alert-minimized-list',
  templateUrl: './alert-minimized-list.component.html',
  styleUrls: ['./alert-minimized-list.component.scss']
})
export class AlertMinimizedListComponent implements OnInit, OnDestroy {
  private destroy$ = new Subject<boolean>();
  limitOfDialogsBeforeChangeStyleToSmall = 6;
  constructor(
    public dialog: MatDialog,
    private cdr: ChangeDetectorRef,
    private eventsService: EventsService,
  ) { }

  dialogRefs = [];

  ngOnInit(): void {
    this.dialog.afterOpened.pipe(
      takeUntil(this.destroy$)).subscribe((item) => {
      if(item.componentInstance instanceof EventDismissComponent && item.componentInstance?.data?.eventItem?.eventTypeId === 3 ){
        this.refreshMinimizedDialogsList(true);
      }
    });
    this.eventsService.onScreenDialog.subscribe(item => {
        if(!item){this.deactivateAllMinDialogs();}
    });
  }
  ngOnDestroy(): void {
    this.destroy$.next(true);
    this.destroy$.complete();
  }
  minimizeDialog(dialogRef: MatDialogRef<any>) {
    dialogRef.addPanelClass('hide');
    this.deactivateMinDialog(dialogRef);
  }
  maximizeDialog(dialogRef: MatDialogRef<any>) {
    this.hideAllPopup();
    dialogRef.removePanelClass('hide');
    this.deactivateAllMinDialogs();
    this.activeMinDialog(dialogRef);
  }

  closeDialog(dialogRef: MatDialogRef<any>) {
    dialogRef.close();
    this.refreshMinimizedDialogsList();
  }

  refreshMinimizedDialogsList(gotNewItem = false){
    this.refillDialogRefs();

    if(gotNewItem){
      this.cdr.detectChanges();
      this.hideAllPopup();
      this.dialogRefs[this.dialogRefs.length-1].removePanelClass('hide');
      this.deactivateAllMinDialogs();
      this.activeLastMinDialog();
    }

    this.dialogRefs.forEach(item=>{
      item.afterClosed().pipe(
        takeUntil(this.destroy$)).subscribe(()=>{
        this.refillDialogRefs();
      });
    });
  }
  private refillDialogRefs(){
    this.dialogRefs = this.dialog.openDialogs.filter(item =>{
      return !item.id?.includes('addEditView');
    });
  }
  private deactivateAllMinDialogs(){
    document.querySelectorAll(`.minimized-dialog-holder .minimized-dialog`).forEach(el=>el.classList.remove('active'));
  }
  private activeMinDialog(dialogRef: MatDialogRef<any>){
    this.actionWithOneDialog(dialogRef,'add');
  }
  private deactivateMinDialog(dialogRef: MatDialogRef<any>){
    this.actionWithOneDialog(dialogRef,'remove');
  }
  private activeLastMinDialog(){
    this.actionWithOneDialog(this.dialogRefs[this.dialogRefs.length-1],'add');
  }
  private actionWithOneDialog(dialogRef: MatDialogRef<any>, action:string){
    document.querySelector(`.minimized-dialog-holder #${dialogRef.id}`)?.classList[action]('active');
  }
  private hideAllPopup(){
    this.dialogRefs.forEach(item => item.addPanelClass('hide'));
  }
}
